<template>
  <v-cta-row :show="show" :offset="80" force-show overlay>
    <template v-slot:float>
      <div class="context-switcher-container d-flex bg-white">
        <v-button :ghost="!isHomeActive" @click="() => goTo('home')">
          <v-icon icon="text_snippet" />
        </v-button>
        <v-button :ghost="!isScheduleActive" @click="() => goTo('calendar')">
          <v-icon icon="calendar_today" />
        </v-button>
      </div>
    </template>
  </v-cta-row>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex"

import vCtaRow from "@/components/CtaRow"

export default {
  components: {
    vCtaRow
  },

  data() {
    return {
      isHomeActive: true,
      isScheduleActive: false,

      activatedContext: {},

      hasPushedRoute: false,
      hasPersistedSwitcher: false,

      show: false
    }
  },

  computed: {
    ...mapState("pages", ["currentPage"]),
    ...mapGetters("pages", ["isSubscribedToPage"]),

    isSubscribed() {
      return this.isSubscribedToPage(this.activatedContext.id)
    },

    routerMethod() {
      return this.hasPushedRoute ? "replace" : "push"
    }
  },

  watch: {
    currentPage: {
      immediate: true,
      handler() {
        if (this.currentPage.show_view_switcher) {
          this.activatedContext = {
            id: this.currentPage.id,
            title: this.currentPage.title,
            path: this.currentPage.path,
            rootId: this.currentPage.rootId,
            show_view_switcher: this.currentPage.show_view_switcher
          }
        }

        this.updateShownState()
      }
    },

    "$route.path": function() {
      this.updateShownState()
    },

    show() {
      // Allows other components to react to the view switcher
      this.setShowViewSwitcher(this.show)

      if (!this.show) {
        this.hasPushedRoute = false
      }
    },

    isSubscribed() {
      this.updateShownState()
    }
  },

  methods: {
    ...mapMutations("ui", ["setShowViewSwitcher"]),

    goTo(context) {
      switch (context) {
        case "home": // TODO: Extract to const
          this.$router[this.routerMethod](this.activatedContext.path)
          break
        case "inbox":
          this.$router[this.routerMethod]("/me/messages")
          break
        case "calendar":
          this.$router[this.routerMethod](
            `/me/schedule?context=${this.activatedContext.id}`
          )

          this.hasPersistedSwitcher = true
          break
      }

      this.hasPushedRoute = true
    },

    updateShownState() {
      if (!this.activatedContext) {
        this.show = false
        return
      }

      if (!this.isSubscribedToPage(this.activatedContext.id)) {
        this.show = false
        return
      }

      switch (this.$route.path) {
        case "/me/schedule":
          this.isScheduleActive = true
          this.isHomeActive = false

          if (
            this.$route.query?.context == this.activatedContext.id &&
            this.hasPersistedSwitcher
          ) {
            this.show = true
          } else {
            this.show = false
          }
          break
        case this.activatedContext.path:
          this.isHomeActive = true
          this.isScheduleActive = false

          this.show = true
          break
        default:
          this.show = false
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.context-switcher-container {
  border-radius: 32px;
  padding: $size--2;
  box-shadow: $box-shadow--large;

  .v-button {
    border-radius: 32px;
    padding: $size--3 $size--5;
  }
}
</style>
